import { Turbo } from "@hotwired/turbo-rails"

// Substitui o window.confirm() nativo por um <dialog> simples.
// Cria o elemento sob demanda (assim sobrevive às trocas de <body> do Turbo).

function build() {
  const dialog = document.createElement("dialog")
  dialog.setAttribute("data-confirm-dialog", "")
  dialog.className = "m-auto w-[calc(100%-2rem)] max-w-sm rounded-xl p-5 shadow-xl backdrop:bg-black/50"
  dialog.innerHTML = `
    <form method="dialog" class="space-y-5">
      <p data-message class="whitespace-pre-line text-sm text-neutral-800"></p>
      <div class="flex justify-end gap-2">
        <button value="cancel" class="outline-none rounded-full border border-stone-300 px-4 py-2 text-sm font-medium text-neutral-700">Cancelar</button>
        <button value="ok" data-ok class="outline-none rounded-full px-4 py-2 text-sm font-black shadow-sm transition bg-amber-500 hover:bg-amber-600 text-neutral-950">Confirmar</button>
      </div>
    </form>`
  document.body.appendChild(dialog)
  return dialog
}

export function confirmDialog(message) {
  const dialog = document.querySelector("dialog[data-confirm-dialog]") || build()
  dialog.querySelector("[data-message]").textContent = message
  return new Promise((resolve) => {
    dialog.addEventListener("close", () => resolve(dialog.returnValue === "ok"), { once: true })
    dialog.returnValue = "cancel"
    dialog.showModal()
  })
}

Turbo.config.forms.confirm = confirmDialog
